
import { Component, Prop, Vue } from 'vue-property-decorator';
import FormGroup from '@/UI/components/common/form/FormGroup.vue';
import moment from 'moment';

import {ServiceStore} from "@/store/modules/Services";
import {IServices, IServicesListItem} from "@/entity/services/services.types";

import VisitCreateForm from "@/form/visits/visitCreate";
import VisitGeneralForm from "@/form/visits/visitGeneral";

import { VisitsStore } from "@/store/modules/Visits";
import { IVisits, IVisitsListItem } from "@/entity/visits/visit.types";

@Component({
    components: { FormGroup },
    methods: { moment }
})
export default class VisitServiceMulty extends Vue {
    @Prop() value!: any;
    @Prop() form!:  VisitCreateForm;
    
    values: any[] = [{}];

    changeQuantity(value: number | string, index: number): void {
        this.values[index].quantity = value;
        this.updateValue();
    }

    updateValue() {

        this.pushToFormData();
        this.form.total_amount = 0;
    
        let ar = this.values;

        for(let i = 0; i < ar.length; i++){
            if(this.service !== undefined && this.service !== null){
                var price = this.service.data.find(e => e.id === ar[i].service_id)!.price_first;
             
                if(price && ar[i].quantity ){
                    this.form.total_amount += price * ar[i].quantity;
                }
                if(price && !ar[i].quantity){
                    this.form.total_amount += price * 1;
                }

                if(!this.values[i].quantity)
                {
                    this.values[i].quantity = 1;
                }

                if(!this.values[i].price)
                {
                    this.values[i].price = price;
                }
            }
        } 

        // this.form.total_amount =  this.service.data.find(e => e.id === this.values).price_first;

    }

    deleteValue(index : any) {
        this.values.splice(index, 1);
        //this.$emit('input', this.values);
        this.pushToFormData();
    }

    pushToFormData(): void {
        this.form.service_data = [];
        for(let i = 0; i < this.values.length; i++)
        {
            this.form.service_data.push(this.values[i]);
        }
    }

    addValue() {
      this.values.push({});

      //this.$emit('input', this.values);
    } 

    get service(): IServices | null {
        return ServiceStore.service;
    }
            
    async created(): Promise<void> {

        var v = Array.from(this.value);
        this.values = v;  

        await ServiceStore.fetchAll({limit: 50, filter: {salon_id: this.$store.state.salon_id}});
    }
}
